<template>
	<div class="mb-2">
		<table-row-list v-for="(item,index) in items"
						v-on:checked="check"
						:key="index"
						:selectable="selectable"
						:showError="showError"
						:showRowNumber="showRowNumber"
						:currentPage="currentPage"
						:pageSize="pageSize"
						:columns="columns"
						:index="index"
						:data="item" />

	</div>

	<table-pagination :total="totalRows"
					  :pageSize="pageSize"
					  :current="currentPage"
					  :totalfilters="totalfilters"
					  v-on:change="(obj)=> $emit('changePage', obj )" />
</template>
<script>

	import tableRowGridList from './rows/row-grid-list'
	import tablePagination from './common/table-pagination'

	export default {
		emits: ['changePage', 'changeOrder', 'checked'],
		components:
		{
			'table-row-list': tableRowGridList,
			'table-pagination': tablePagination
		},

		props:
		{
			'items': Array,
			'actions': Array,
			'entity': Function,
			'totalRows': Number,
			'totalfilters': Number,
			'currentPage': Number,
			'selectable': Boolean,
			'pageSize': Number,
			'orderPropertyName': String,
			'orderDescending': Boolean,

			'showRowNumber': {
				type: Boolean,
				default: true
			},

			'showError': {
				type: Boolean,
				default: false
			},

			'showForeignKey': {
				type: Boolean,
				default: false
			}
		},

		data()
		{
			return {
				columns: [],
				order: '',
				orderDesc: false
			}
		},

		beforeMount()
		{
			this.initColumns()
		},

		beforeUpdate()
		{
			this.initColumns()
		},

		methods:
		{
			initColumns()
			{
				var columns = {}
				for (var item of this.items)
				{
					for (const key of Object.keys(item.value || {}).concat(this.showError ? Object.keys(item.error || {}) : []))
					{
						columns[key] = true
					}
				}

				this.columns = Object.keys(columns)
			},

			getProps(entity)
			{
				var props = []
				entity = entity || new this.entity({})
				for (var key in entity.props)
				{
					const prop = entity.props[key];

					if (prop.foreignKey && this.showForeignKey == false)
						continue;

					if (!prop.display.isVisible || this.columns.indexOf(key) == -1)
						continue;

					props.push(entity.props[key])
				}

				return props
			},

			check()
			{
				this.$emit('checked', this.getChecked())
			},

			checkAll(e)
			{
				for (const item of this.items)
				{
					item.checked = e.target.checked
				}

				this.$emit('checked', this.getChecked())
			},

			getChecked()
			{
				var items = []
				for (const item of this.items)
				{
					if (item.checked == true) { items.push(item) }
				}

				return items
			},

			checkedLen()
			{
				var len = 0
				for (const item of this.items) { len += item.checked ? 1 : 0 }

				return len
			},

			changeOrder(prop)
			{
				var orderPropertyName = prop.name;
				var orderDescending = false;

				if (this.orderPropertyName == prop.name)
				{
					orderDescending = !this.orderDescending;
				}

				this.$emit('changeOrder', {
					orderPropertyName: orderPropertyName,
					orderDescending: orderDescending
				});
			}
		},
	}
</script>
<style scoped>
	.table th.order-column {
		position: relative;
		padding-left: 30px;
	}

		.table th.order-column .order-key {
			position: absolute;
			left: 0;
			width: 25px;
			top: 5px;
			text-align: center;
			cursor: pointer;
		}
</style>
